<template>
  <div class="intro-graphic-content" id="identidade-visual-grafismos-introducao" data-search-anchor>
    <div
      class="intro-graphic-card-item"
      :style="{ backgroundImage: `url(${introGraphicImageSrc})` }"
    ></div>    
    <div class="description-graphic-content">
      <p class="intro-graphic-description">{{ introGraphicDescription }}</p>
      <p class="intro-graphic-description-paragraph1">{{ introGraphicDescriptionParagraph1 }}</p>
      <p class="intro-graphic-description-paragraph">{{ introGraphicDescriptionParagraph2 }}</p>
      <p class="intro-graphic-description-paragraph">{{ introGraphicDescriptionParagraph3 }}</p>

      <div class="button-graphic-wrapper">
        <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar grafismos"          
        />        
    </div>     
    </div>
    
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class GraphicIntroSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store)

  onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Grafismos'

  get introGraphicDescription(): string {
    return this.getElementText(1, 0)
  }
  get introGraphicDescriptionParagraph1(): string {
    return this.getElementText(1, 1)
  }
  get introGraphicDescriptionParagraph2(): string {
    return this.getElementText(1, 2)
  }
  get introGraphicDescriptionParagraph3(): string {
    return this.getElementText(1, 3)
  }
  get introGraphicImageSrc(): string {
    return this.getElementMedia(1, 0)
  }

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.intro-graphic-content {  
  display: grid;
  grid-template-columns: 54% 46%;
  max-width: 1032px;
  width: 100%;  
}

.intro-graphic-title {
  font-size: 65px;
  font-weight: 400;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  padding: 0 3rem 3rem 3rem;
  margin: 0;
}

.description-graphic-content {
  width: 488px;
  white-space: pre-line;

  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.intro-graphic-card-item {
  position: relative;  
  width: 538px;
  height: 566px;
  margin-top: -60px;
  background-repeat: no-repeat;
  background-position: center;  
  background-size: contain;
}

.button-graphic-wrapper {
    position: relative;
    top: 2rem;
}
</style>
